/**
 * Accessibility skip-to-content link.
 * Visually hidden by default; becomes visible on keyboard focus so screen-reader
 * and keyboard users can jump straight to #main-content.
 */
const SkipToContent = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[10000] focus:px-4 focus:py-2 focus:bg-foreground focus:text-background focus:rounded focus:outline-none focus:ring-2 focus:ring-ring"
  >
    Skip to content
  </a>
);

export default SkipToContent;
